import React, { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import backgroundImage from '../background.webp';
import cardBackgroundImage from '../cardbackground.webp';

const AdminPanel = ({ user, goBack, goHome, setCurrentPage }) => {
  const [streamId, setStreamId] = useState('');
  const [cardDescription, setCardDescription] = useState('Live stream unavailable');
  const [textColor, setTextColor] = useState('Black');
  const [isBold, setIsBold] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkSession = async () => {
      const { data } = await supabase.auth.getSession();
      if (data.session && data.session.access_token) {
        console.log('Access Token:', data.session.access_token);
        fetchConfig();
      } else {
        console.log('No session available. Redirecting to myAccount.');
        window.location.href = '/myAccount';
      }
    };
    checkSession();
  }, []);

  const fetchConfig = async () => {
    try {
      setLoading(true);
      const { data, error } = await supabase
        .schema('api')
        .from('stream_config')
        .select('*')
        .eq('id', 1)
        .single();
      if (error) throw error;
      if (data) {
        setStreamId(data.stream_id || '');
        setCardDescription(data.card_description || '');
        setTextColor(data.text_color || 'Black');
        setIsBold(data.is_bold || false);
      } else {
        setStreamId('');
        setCardDescription('');
        setTextColor('Black');
        setIsBold(false);
      }
    } catch (error) {
      console.error('Error fetching config:', error);
      setStreamId('');
      setCardDescription('');
      setTextColor('Black');
      setIsBold(false);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    try {
      const { error } = await supabase
        .schema('api')
        .from('stream_config')
        .update({ stream_id: streamId, card_description: cardDescription, text_color: textColor, is_bold: isBold })
        .eq('id', 1);
      if (error) throw error;
      await fetchConfig();
      toast.success('Configuration updated!');
    } catch (error) {
      console.error('Error updating config:', error.message);
      toast.error('Failed to update configuration: ' + error.message);
    }
  };

  if (!user) return <div>Please log in to access the admin panel.</div>;

  const containerStyle = {
    backgroundImage: `url(${backgroundImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    minHeight: '100vh',
    padding: '20px',
  };

  const cardStyle = {
    width: '80%',
    maxWidth: '800px',
    margin: '0 auto 20px',
    backgroundImage: `url(${cardBackgroundImage})`,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    border: '2px solid #fff',
    borderRadius: '10px',
    padding: '20px',
    textAlign: 'center',
  };

  const buttonStyle = {
    backgroundColor: '#ccc',
    border: '2px solid black',
    borderRadius: '10px',
    padding: '10px 20px',
    width: '120px',
    fontFamily: 'Times New Roman, Times, serif',
    fontSize: '16px',
    fontWeight: 'bold',
    boxShadow: '3px 3px 5px rgba(0,0,0,0.3)',
  };

  return (
    <div style={containerStyle}>
      <h2 style={{ textAlign: 'center', fontWeight: 'bold' }}>Admin Panel</h2>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <>
          {/* JulieCam Card */}
          <div style={cardStyle}>
            <div>
              <label>Stream ID: </label>
              <input
                type="text"
                value={streamId}
                onChange={(e) => setStreamId(e.target.value)}
                placeholder="Enter Stream ID"
                style={{ width: window.innerWidth > 600 ? '300px' : '200px' }} // Consistent width
              />
            </div>
            <div style={{ marginTop: '10px' }}>
              <label>Card Description: </label>
              <input
                type="text"
                value={cardDescription}
                onChange={(e) => setCardDescription(e.target.value)}
                placeholder="Enter Description"
                style={{ width: window.innerWidth > 600 ? '300px' : '200px' }} // Match Stream ID width
              />
            </div>
            <div style={{ marginTop: '10px' }}>
              <label>Text Color: </label>
              <select value={textColor} onChange={(e) => setTextColor(e.target.value)}>
                <option value="Red">Red</option>
                <option value="Green">Green</option>
                <option value="Black">Black</option>
                <option value="Blue">Blue</option>
              </select>
            </div>
            <div style={{ marginTop: '10px' }}>
              <label>Bold Text: </label>
              <input
                type="checkbox"
                checked={isBold}
                onChange={(e) => setIsBold(e.target.checked)}
              />
            </div>
            <button onClick={handleSave} style={{ ...buttonStyle, marginTop: '10px' }}>
              Save
            </button>
          </div>
          {/* Two Blank Cards */}
          <div style={cardStyle}></div>
          <div style={cardStyle}></div>
          {/* Back and Home Buttons */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '16px', marginTop: '20px' }}>
            <button onClick={goBack} style={buttonStyle}>
              Back
            </button>
            <button onClick={goHome} style={buttonStyle}>
              Home
            </button>
          </div>
        </>
      )}
      <ToastContainer />
    </div>
  );
};

export default AdminPanel;